/*
 * Copyright (C) Compliance Audit Systems Limited - All Rights Reserved
 * Unauthorised copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Sudara Fernando <sudara@complianceauditsystems.com>, ${DATE}
 *
 */

export enum SubscriptionResourceType {
    project = 0,
    site = 1
}

export interface CurrentResourceUsage {
    readonly resourceType: keyof typeof SubscriptionResourceType;
    readonly allowedResources: number;
    readonly usedResources: number;
}
